import emailjs from '@emailjs/browser';
import { EMAIL_SERVICE_ID, EMAIL_TEMPLATE_ID, EMAIL_PUBLIC_KEY } from '@/config/api';

// This is a placeholder for the email service functionality
// Will be implemented properly when connected with Supabase

export async function sendItineraryEmail(
  email: string, 
  subject: string, 
  content: string
): Promise<boolean> {
  try {
    // Validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      throw new Error('Invalid email format');
    }

    // EmailJS template parameters
    const templateParams = {
      to_email: email,              // maps to "To Email: {{to_email}}"
      name: 'TravelAI Assistant',   // maps to {{name}} (From Name)
      email: email,                 // maps to {{email}} (Reply To)
      title: subject,               // maps to {{title}} in Subject
      message: content              // maps to {{message}} in Content
    };

    // Send email using EmailJS
    const response = await emailjs.send(
      EMAIL_SERVICE_ID,
      EMAIL_TEMPLATE_ID,
      templateParams,
      EMAIL_PUBLIC_KEY
    );

    if (response.status === 200) {
      console.log('Email sent successfully to:', email);
      return true;
    }
    throw new Error('Failed to send email');
  } catch (error) {
    console.error('Error sending email:', error);
    return false;
  }
}
